import features from '@/constants/featureDetection.json';
import { LANG } from '~/constants/config';
export default (ctx, inject) => {
  inject('supports', (featureName) => {
    const feature = features?.[featureName];
    if (!feature) return true;
    switch (feature.type) {
      case 'lang':
        return feature.value.includes(LANG);
      default:
        return true;
    }
  });
};
